import React from 'react';
import { compose } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './AvailMainSideSummaryTaxes.js';
import { RichText } from '@synergycms_core/components/generic';
import connect from 'react-redux/es/connect/connect';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import Price from '@synergycms_core/components/generic/Price';
import classnames from 'classnames/bind';
import { getTaxText } from '../../../../utils';

const AvailMainSideSummaryTaxes = class AvailMainSideSummaryTaxes extends React.Component {
  static displayName = 'AvailMainSideSummaryTaxes';

  render() {
    const { config, theme } = this.props,
      {
        taxes,
        included,
        title,
        cityTax,
        summaryBreakdownMode,
        stepCode,
        forceSymbol,
      } = config;

    const { classes } = theme.styles;
    let cx = classnames.bind(classes);

    return (
      <>
        {title && (
          <div className={[classes.contentModuleRow, classes.contentFlexRow].join(' ')}>
            <div className={[classes.contentModuleCell, classes.contentFlexCell].join(' ')}>
              <RichText
                text={title}
                innerStyle={['roboto11Black700', 'bold']}
                translate={true}
                ucFirst={true}
              />
            </div>
          </div>
        )}
        {taxes && taxes.length === 1 && included && (
          <div className={classes.contentModuleRow}>
            <div className={[classes.contentModuleCell, classes.large].join(' ')}>
              <RichText
                ucFirst={true}
                text={'_%impuestos incluidos%_'}
                innerStyle={['roboto15GrayBold']}
                translate={true}
              />
              {' '}
              <RichText
                text={taxes[0].is_percent ? ' (' + taxes[0].value + '%)' : ''}
                innerStyle={['roboto15GrayBold']}
                translate={true}
              />
            </div>
            <div className={[classes.contentModuleCell, classes.short].join(' ')}>
              <Price
                innerStyle={['roboto13GrayBold']}
                amount={taxes[0].tax_amount}
                forceHotelCurrency={stepCode === 'confirmation'}
                forceSymbol={forceSymbol}
              />
            </div>
          </div>
        )}
        {taxes && taxes.length > 0 && ( taxes.length > 1 || !included ) && (
          <>
            {included && (
              <div className={[classes.contentModuleRow].join(' ')}>
                <RichText
                  text={'_%impuestos incluidos%_'}
                  innerStyle={['roboto15GrayBold', 'bold', classes.taxesCell, classes.taxesTitle]}
                  translate={true}
                  ucFirst={true}
                />
              </div>
            )}
            {!included && (
              <div className={[classes.contentModuleRow].join(' ')}>
                <RichText
                  text={'_%no incluido%_'}
                  innerStyle={['roboto11Black400', classes.taxesCell, classes.taxesTitle]}
                  translate={true}
                  ucFirst={true}
                />
              </div>
            )}
            {taxes.map((tax, index) => (
              <div className={[classes.contentModuleRow, classes.removeGap, included ? classes.removeGapLarge : ''].join(' ')}>
                <div className={[classes.contentModuleCell, classes.large, cx({taxesCell: index === 0}) ].join(' ')}>
                  <RichText
                    text={getTaxText(tax, summaryBreakdownMode)} 
                    innerStyle={['roboto11SoftGray300', classes.taxes]}
                    translate={true}
                  />
                  {' '}
                  <RichText
                    text={tax.is_percent ? ' (' + tax.value + '%)' : ''}
                    innerStyle={['roboto11SoftGray300', classes.taxes]}
                    translate={true}
                  />
                </div>
                <div className={[classes.contentModuleCell, classes.contentModuleCellPrice, classes.short, cx({taxesCell: index === 0})].join(' ')}>
                  <Price
                    innerStyle={['roboto11SoftGray300', classes.priceNumbers, classes.taxes]}
                    amount={tax.tax_amount}
                    forceHotelCurrency={stepCode === 'confirmation'}
                    forceSymbol={forceSymbol}
                  />
                </div>
              </div>
            ))}
          </>
        )}
        {cityTax && (
          <div className={[classes.contentModuleRow, classes.contentFlexRow].join(' ')}>
            <div className={[classes.contentModuleCell, classes.contentFlexCell, classes.flexCellFullWidth, classes.alignLeft].join(' ')}>
              <RichText dangerouslySetInnerHTML={cityTax} innerStyle={['roboto11Black400']} />
            </div>
          </div>
        )}
      </>
    );
  }
};

const mapStateToProps = (store, ownProps) => {
  const stepCode = store.getIn(['customer', 'step', 'current_step', 'code']);
  
  return {
    stepCode: stepCode,
  };
};

export default compose(
  validateAsyncComponent(mapStateToProps, []),
  connect(
    mapStateToProps,
  ),
  PropertyManager([
    'taxes',
    'included',
    'title',
    'cityTax',
    'summaryBreakdownMode',
    'stepCode',
    'forceSymbol',
  ]),
  withThemeJSS({ styleFile, link: true }),
  withContent('i18n')
)(AvailMainSideSummaryTaxes);
